import React, { useEffect, useState } from "react";
import "./App.scss";
import Display from "./Display/Display";
import Settings from "./Settings/Settings";
import InvalidURL from "./Utilities/InvalidURL";
import VenueOnboarding from "./VenueOnboarding/VenueOnboarding";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthContext } from "./Context/Auth";
import TokenUtil from "./Utilities/TokenUtil";

function App() {
  const [hostName] = useState(window && window.location && window.location.hostname);
  const [environment] = useState(
    ["venuepids-dev.tramtracker.com.au", "localhost"].includes(hostName)
      ? "dev"
      : ["venuepids-test.tramtracker.com.au"].includes(hostName)
      ? "test"
      : "prod"
  );
  const [urlParams, setUrlParams] = useState(getUrlParams());
  const [errorCount, setErrorCount] = useState(0);
  const [authToken, setAuthToken] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const initalValue = localStorage.isPortrait
    ? localStorage.isPortrait === "true"
    : false;
  const [isPortrait, setIsPortrait] = useState(initalValue);
  const [displayRecords, setDisplayRecords] = useState({});

  useEffect(() => {
    if (urlParams.token.length > 0) {
      const encodedToken = urlParams.token[0];
      let decodedToken = null;
      try {
        decodedToken = TokenUtil.verify(encodedToken);
      } catch (err) {
        setIsValid(false);
        setAuthToken({});
      }
      if (
        decodedToken &&
        "key" in decodedToken &&
        decodedToken.key === "ytvenuepidaccess"
      ) {
        setIsValid(true);
        setAuthToken(decodedToken);
      } else {
        setIsValid(false);
        setAuthToken(null);
      }
    } else {
      setIsValid(false);
      setAuthToken(null);
    }
  }, [urlParams.token]);

  useEffect(() => {
    if (isPortrait) {
      localStorage.isPortrait = "true";
    } else {
      localStorage.isPortrait = "false";
    }
    window.dispatchEvent(new Event("resize"));
  }, [isPortrait]);

  function reCheckAuth() {
    setUrlParams(getUrlParams());
  }

  return (
    <AuthContext.Provider
      value={{
        authToken,
        isValid,
        setAuthToken,
        isPortrait,
        setIsPortrait,
        reCheckAuth,
        displayRecords,
        setDisplayRecords,
      }}
    >
      <Router>
        <Switch>
          <PrivateRoute
            exact
            path="/"
            render={(props) => (
              <Display
                {...props}
                environment={environment}
                urlParams={urlParams}
                errorCount={errorCount}
                setErrorCount={setErrorCount}
              />
            )}
          />
          <PrivateRoute path="/settings" component={Settings} exact />
          <Route path="/venue-onboarding" component={VenueOnboarding} exact />
          <Route path="*" component={InvalidURL} />
        </Switch>
      </Router>
    </AuthContext.Provider>
  );
}

function getUrlParams() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return {
    stops: params.getAll("stop"),
    token: params.getAll("token"),
    //Testing Data
    // stops: [3512, 2353, 1353, 3412], stop=3512&stop=2353&stop=1353&stop=3412
    // stops: [1032, 1033, 2032, 2033], stop=1032&stop=1033&stop=2032&stop=2033
    // stops: [3204, 3205, 3304, 3305, 2215], stop=3204&stop=3205&stop=3304&stop=3305
    // stops: [2027, 2029, 1027, 1029, 2150, 1150], stop=2027&stop=2029&stop=1027&stop=1029&stop=2150&stop=1150
  };
}

export default App;
